export default "__VITE_ASSET__2c08345b__"